import axios from "axios";
import useSWR from "swr";
import { API_ENDPOINT } from "../abis/constants";
import { useState } from "react";
import { BrowserProvider, Eip1193Provider, ethers } from "ethers";
import { useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";
import abiERC20 from '../abis/erc20.json'
import { useChainInfo } from "./config";

export function useTokenInfo(tokenAddress: `0x${string}`, network: string, pageNumber: number, pageSize: number) {
    const { address } = useWeb3ModalAccount()
    const { chain, getChain } = useChainInfo()
    const { walletProvider } = useWeb3ModalProvider()

    const { data: tokenInfo, mutate } = useSWR(
        tokenAddress ? ['/info/token', tokenAddress, network, chain, address, walletProvider, pageNumber, pageSize] : undefined,
        async () => {
            const { data } = await axios.get(`${API_ENDPOINT}/tokens/${network}/${tokenAddress}`, {
                params: {
                    pageNumber, pageSize
                }
            })
            const tokenChain = getChain(network)
            if (tokenChain) {
                const provider = new ethers.JsonRpcProvider(tokenChain.rpcUrl)
                let providerOrSigner: any = provider
                if (address && tokenChain.chainId === chain?.chainId) {
                    const ethersProvider = new BrowserProvider(walletProvider as Eip1193Provider)
                    providerOrSigner = await ethersProvider.getSigner()
                }
                const tokenContract = new ethers.Contract(tokenAddress, abiERC20, providerOrSigner)
                const ethismContract = new ethers.Contract(tokenChain.contractAddress, tokenChain.abi, provider)
                data.tokenContract = tokenContract
                // data.ethismContract = ethismContract
                data.curveBalance = await tokenContract.balanceOf(tokenChain.contractAddress).catch(() => 0n)
                if (address) {
                    data.balance = await tokenContract.balanceOf(address).catch(() => 0n)
                    data.allowance = await tokenContract.allowance(address, tokenChain.contractAddress).catch(() => 0n)
                }
                data.poolInfo = await ethismContract.tokenPools(tokenAddress).catch(() => undefined)
                // data.marketCap = await factoryContract.getTokenMarketCap(tokenAddress).catch(() => 0n)
            }
            return data
        }, {
        refreshInterval: 5000,
        keepPreviousData: true,
    }
    )
    return {
        tokenInfo, reload: mutate
    }
}

export function useTokens(filter: any) {
    const { data, mutate } = useSWR(
        ['/list/tokens', filter],
        async () => {
            const { data } = await axios.get(`${API_ENDPOINT}/tokens`, {
                params: filter,
            })
            return data
        }, {
        refreshInterval: 5000,
        keepPreviousData: true
    }
    )
    return {
        tokens: data?.tokenList ?? [],
        count: data?.tokenCount ?? 0,
        reload: mutate
    }
}

export function useNewTrades() {
    const [latestTradeId, setLatestTradeId] = useState<string>()

    const { data, mutate } = useSWR(
        '/list/trades',
        async () => {
            const { data: { trades } } = await axios.get(API_ENDPOINT, {
                params: {
                    latestTradeId,
                }
            })
            if (trades.length) {
                setLatestTradeId(trades[0].id)
            }
            return trades.reverse()
        }, {
        refreshInterval: 5000,
    }
    )
    return {
        trades: data,
        reload: mutate
    }
}